import { useQuery } from '@tanstack/react-query';
import { alertsService } from '../services/apiServices';

// Query keys
export const ALERT_KEYS = {
  all: ['alerts'] as const,
  list: () => [...ALERT_KEYS.all, 'list'] as const,
  count: () => [...ALERT_KEYS.all, 'count'] as const,
};

// Fetch all alerts
export const useAlerts = () => {
  return useQuery({
    queryKey: ALERT_KEYS.list(),
    queryFn: () => alertsService.getAll(),
  });
};

// Fetch alert count
export const useAlertCount = () => {
  return useQuery({
    queryKey: ALERT_KEYS.count(),
    queryFn: () => alertsService.getCount(),
    refetchOnWindowFocus: false,
  });
};
